import { type IAreaTicket } from '../../../../models/area-ticket-model';
import TicketSuggestionApiModel from './ticket-suggestion.api-model';

export default class AreaTicketApiModel {
  public static mapToBusinessModel(apiModel: AreaTicketApiModel): IAreaTicket {
    return {
      name: apiModel.name,
      areaId: apiModel.areaId,
      validityTextAsHtml: apiModel.validityTextAsHtml,
      descriptionAsHtml: apiModel.descriptionAsHtml,
      imageUrl: apiModel.imageUrl,
      ticketSuggestions: apiModel.ticketSuggestions.map(TicketSuggestionApiModel.mapToBusinessModel),
    };
  }

  name!: string;
  areaId!: number;
  validityTextAsHtml!: string;
  descriptionAsHtml!: string;
  imageUrl?: string;
  ticketSuggestions!: TicketSuggestionApiModel[];
}

